import {Box, Heading, useToast, Flex} from '@chakra-ui/react';
import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { treatmentExerciseService } from 'services/treatmentExerciseService';
import ExerciseForm, { ExerciseFormSubmitData } from 'features/treatments/components/ExerciseForm';


interface Props {
    planId: string;
}


export default function CreateExercisesPreview({ planId }: Props) {

    const toast = useToast();
    const queryClient = useQueryClient();
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async (formData: ExerciseFormSubmitData) => {
    setIsSaving(true);
    try {
      await treatmentExerciseService.prescribe(planId, formData);
      
      toast({ 
        title: 'Ejercicio agregado al plan', 
        status: 'success', 
        duration: 2500, 
        isClosable: true, 
        position: 'top-right' 
      });
      
      queryClient.invalidateQueries({ queryKey: ['treatment-exercises', planId] });
    } catch (err: any) {
      const msg = err?.response?.data?.message ?? 'Error al guardar el ejercicio';
      toast({
        title: 'Error',
        description: Array.isArray(msg) ? msg.join(' · ') : msg,
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Box maxW="600px" mx="auto" p="6" bg="white" borderRadius="15px" boxShadow="sm">
      <Heading size="md" mb="6" color="gray.700">
        Previsualización: Añadir Nuevo Ejercicio
      </Heading>
      
      {/* Renderizamos el formulario directamente en la página */}
      <ExerciseForm 
        onSubmit={handleSave} 
        isSaving={isSaving} 
        submitBtnLabel="Añadir al Plan"
      />
    </Box>
  );
}